import React from 'react';
import { Question } from '@phosphor-icons/react';
import { useI18n } from '../../contexts/I18nContext';
import { STATE_META } from '../../lib/movement';
import { MOVEMENT_TYPES, formatMinutes } from '../../lib/alertText';

// "Why did this fire?" — the evaluation record (event meta) behind an inactivity / silence alert.
export function WhyFired({ type, meta }) {
  const { t } = useI18n();
  if (!meta || !MOVEMENT_TYPES.includes(type)) return null;
  const threshold = type === 'no_movement' ? meta.inactivity_threshold_min
    : type === 'device_silent' ? meta.silence_threshold_min : null;
  const rows = [
    meta.minutes_since_motion != null && type !== 'device_silent' && [t('why_since_motion'), formatMinutes(meta.minutes_since_motion, t)],
    meta.minutes_since_sample != null && [t('why_since_sample'), formatMinutes(meta.minutes_since_sample, t)],
    threshold != null && [t('why_threshold'), formatMinutes(threshold, t)],
    type === 'no_rise' && meta.expected_up_by && [t('why_up_by'), meta.expected_up_by],
    meta.night_start && meta.night_end && [t('why_night'), `${meta.night_start}–${meta.night_end}`],
    meta.threshold_source && [t('why_source'), t(meta.threshold_source === 'organization' ? 'why_src_org' : 'why_src_default')],
    meta.state && [t('why_state'), t(STATE_META[meta.state]?.key || 'mv_state_nodata')],
    meta.evaluated_at_local && [t('why_checked'), `${String(meta.evaluated_at_local).slice(11, 16)}${meta.timezone ? ` · ${meta.timezone}` : ''}`],
  ].filter(Boolean);
  return (
    <details className="bg-white rounded-xl border border-stone_line group" data-testid="alert-why-fired">
      <summary className="cursor-pointer list-none px-4 py-3 flex items-center gap-2 text-sm text-ink font-medium" data-testid="alert-why-toggle">
        <Question size={16} className="text-sage-600" weight="duotone" />
        {t('why_title')}
      </summary>
      <dl className="px-4 pb-4 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-xs">
        {rows.map(([k, v]) => (
          <React.Fragment key={k}>
            <dt className="text-ink-muted">{k}</dt>
            <dd className="text-ink tabular-nums">{v}</dd>
          </React.Fragment>
        ))}
      </dl>
      <p className="px-4 pb-4 text-[11px] text-ink-muted">{t('why_approx')}</p>
    </details>
  );
}
